import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Text, TextField } from '../../../components';
import { Avatar, Col, Radio, Row } from 'antd';
import { IoArrowBack } from 'react-icons/io5';
import { ApiCaller, Colors, Utils } from '../../../config';
import { UserOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { ShiftDropOrSwap, ShiftTorAction } from '../../../store/actions';
import Circular from '../../../components/Loader/Circular';
import moment from 'moment';
import { calculateHours } from '../../../config/util/HoursCalculator';
import DateTimeComponent from '../../../config/util/DateAndTimeParser';
import { useMutation } from 'react-query';
import dayjs from 'dayjs';
import socketIO from 'socket.io-client';
import useColors from '../../../hooks/useColors';

const DropSwapRequestDetail = () => {
    const { colorPrimary } = useColors();

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const lastMessageRef = useRef(null);

    useEffect(() => {
        dispatch(ShiftDropOrSwap.GetDropOrSwapDetail(Number(id)));
    }, []);

    const { detailLoader, dropOrSwapDetailData } = useSelector(
        (state) => state?.ShiftDropOrSwapReducer,
    );
    const { user } = useSelector((state) => state?.AppReducer);

    const isRole = user?.userRole[0];
    let currentUserId = user?.id;
    let channelId = dropOrSwapDetailData?.chatChannel?.id;

    console.log('userrrr', dropOrSwapDetailData);

    let first_Name =
        dropOrSwapDetailData?.shift?.shiftUser?.[0]?.user?.firstName || 'N/A';
    let last_Name =
        dropOrSwapDetailData?.shift?.shiftUser?.[0]?.user?.lastName || 'N/A';

    const [status, setStatus] = useState('');
    const [radioValue, setRadioValue] = useState(1);
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState('');
    const [chatEffectRenderer, setChatEffectRenderer] = useState(false);

    useEffect(() => {
        if (
            dropOrSwapDetailData &&
            (dropOrSwapDetailData?.status === 'approved' ||
                dropOrSwapDetailData?.status === 'accepted')
        ) {
            let tempMsgArray = [];
            dropOrSwapDetailData?.chatChannel?.messages?.forEach((msg) => {
                tempMsgArray.push({
                    messageId: msg.id,
                    message: msg.message,
                    messageDateTime: msg.created_at,
                    messageSenderId: msg.sender?.id,
                    messageSenderUserName: msg.sender?.userName,
                    messageSenderFname: msg.sender?.firstName,
                    messageSenderLname: msg.sender?.lastName,
                    messageSenderImg:
                        msg.sender?.profileImg &&
                        msg.sender?.profileImg[0]?.url,
                });
            });
            setMessages(tempMsgArray);
        }
    }, [dropOrSwapDetailData]);

    useEffect(() => {
        let socket = socketIO.connect(
            `${process.env.REACT_APP_SOCKET_HOST}:${process.env.REACT_APP_SOCKET_PORT}`,
        );
        if (channelId) {
            socket.emit('joinRoom', { room: 'chatChannel.' + channelId });
            socket.on('chatMessages', (data) => {
                console.log('dataaa', data);
                setMessages((prevMessages) => [
                    ...prevMessages,
                    {
                        messageId: data.id,
                        message: data.message,
                        messageDateTime: data.created_at,
                        messageSenderId: data.sender?.id,
                        messageSenderUserName: data.sender?.userName,
                        messageSenderFname: data.sender?.firstName,
                        messageSenderLname: data.sender?.lastName,
                        messageSenderImg:
                            data.sender?.profileImg &&
                            data.sender?.profileImg[0]?.url,
                    },
                ]);
            });
        }
        // Cleanup the socket listeners when the component unmounts
        return () => {
            socket.off('joinRoom');
            socket.off('chatMessages');
            socket.disconnect();
        };
    }, [channelId, chatEffectRenderer]);

    useEffect(() => {
        // scroll to bottom every time messages change
        lastMessageRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const requestMutation = useMutation(
        async (data) => {
            let res = await ApiCaller.Patch(
                `/shift/drop-request/${Number(id)}/approve`,
                data,
            );
            return res;
        },
        {
            onSuccess: (res) => {
                Utils.showMessage('success', res?.data?.message);
                navigate('/workforce-management/drop-swap-requests');
            },
            onError: (error) => {
                Utils.showMessage('error', error?.response?.data?.message);
            },
        },
    );

    const requestHandler = (newStatus) => {
        setStatus(newStatus);
        let data = {
            status: newStatus, // Enum: "approved" or "denied"
        };
        const endpoint = `/shift/drop-request/${Number(id)}/approve`;

        requestMutation.mutate({ status: newStatus });
    };

    console.log('msgs', messages);

    const handleMessageChange = (e) => {
        setMessage(e.target.value);
    };

    const btnHandler = async () => {
        if (message.length == 0) {
            return;
        } else {
            setChatEffectRenderer(true);
            setMessage('');
            let payload = {
                message: message,
                type: 'text',
            };
            let res = await ApiCaller.Post(
                `/chat-channel/${Number(channelId)}/message`,
                payload,
            );
        }
    };

    return (
        <>
            <Row className="mb-7">
                <h2 className={'text-xl font-bold'}>Workforce Management</h2>
            </Row>
            {detailLoader ? (
                <Circular
                    spinning={detailLoader}
                    size={40}
                    color={colorPrimary}
                    containerStyle={{
                        width: '100%',
                        height: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            ) : (
                <Row
                    justify={'space-between'}
                    align={'start'}
                    className="p-1 w-full mb-2"
                >
                    <Col
                        xl={
                            (isRole !== 'supervisor' &&
                                dropOrSwapDetailData?.status == 'approved') ||
                            dropOrSwapDetailData?.status === 'accepted'
                                ? 15
                                : 24
                        }
                        lg={
                            (isRole !== 'supervisor' &&
                                dropOrSwapDetailData?.status == 'approved') ||
                            dropOrSwapDetailData?.status === 'accepted'
                                ? 15
                                : 24
                        }
                        md={
                            (isRole !== 'supervisor' &&
                                dropOrSwapDetailData?.status == 'approved') ||
                            dropOrSwapDetailData?.status === 'accepted'
                                ? 13
                                : 24
                        }
                        sm={24}
                        xs={24}
                        className="mb-6"
                    >
                        <Row
                            style={{ background: 'white' }}
                            className="rounded-lg py-3 px-2 mb-6"
                        >
                            <div className="w-full flex items-center justify-between px-3 flex-wrap">
                                <h3 className="text-lg font-semibold">
                                    Details of SDR
                                </h3>
                                <span>
                                    <IoArrowBack
                                        className="cursor-pointer inline "
                                        size={18}
                                        onClick={() =>
                                            navigate(
                                                '/workforce-management/drop-swap-requests',
                                            )
                                        }
                                    />
                                    <span className="ml-2">Back</span>
                                </span>
                            </div>
                            <div
                                className="w-full flex items-center justify-between p-3 m-3 flex-wrap"
                                style={{ border: '1px solid #F9F9FA' }}
                            >
                                <Text.Basic
                                    text={`Offered Shift`}
                                    fontSize="14"
                                    font-weight="500"
                                    textAlign="start"
                                />
                                <span
                                    style={{ color: colorPrimary }}
                                    className="font-semibold"
                                >
                                    {dropOrSwapDetailData?.status ===
                                    'pending' ? (
                                        <>
                                            Pending Acceptance
                                            <Text.Basic
                                                text={` from recipient`}
                                                fontSize="14"
                                                font-weight="500"
                                                color="#4E5D78"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            {dropOrSwapDetailData?.status}{' '}
                                            {/* <Text.Basic
                                                text={`${'Razaaaa'}`}
                                                fontSize="14"
                                                font-weight="500"
                                                color="#4E5D78"
                                            /> */}
                                        </>
                                    )}
                                </span>
                            </div>

                            <div
                                className="w-full flex items-start justify-between p-3 m-3 flex-wrap"
                                style={{ border: '1px solid #F9F9FA' }}
                            >
                                <div className="flex items-center gap-2 flex-wrap ">
                                    {dropOrSwapDetailData?.shift?.shiftUser
                                        ?.user?.profileImg ? (
                                        <Avatar
                                            src={
                                                dropOrSwapDetailData?.shift
                                                    ?.shiftUser?.user
                                                    ?.profileImg[0]?.url
                                            }
                                            size={35}
                                        />
                                    ) : (
                                        <Avatar
                                            icon={<UserOutlined />}
                                            size={35}
                                        />
                                    )}
                                    <div className="flex flex-col items-start justify-center flex-wrap font-extrabold">
                                        <Text.Basic
                                            text={`${moment(dropOrSwapDetailData?.shift?.shiftDate).format('ddd MMM DD, YYYY')} from ${dropOrSwapDetailData?.shift?.startTime} to ${dropOrSwapDetailData?.shift?.endTime}`}
                                            fontSize="14"
                                            textAlign="start"
                                        />
                                        <Text.Basic
                                            text={`${first_Name} ${last_Name} at ${dropOrSwapDetailData?.shift?.location?.name}`}
                                            fontSize="12"
                                            font-weight="400"
                                            textAlign="start"
                                        />
                                    </div>
                                </div>
                            </div>
                            {dropOrSwapDetailData?.status === 'pending' && (
                                <div className="flex justify-between items-center w-full">
                                    <div className="flex">
                                        <Button.Basic
                                            loader={
                                                status === 'approved' ||
                                                status === 'accepted'
                                                    ? requestMutation?.isLoading
                                                    : false
                                            }
                                            size="large"
                                            text="Approve"
                                            onClick={() =>
                                                requestHandler('approved')
                                            }
                                            buttonStyle={{
                                                backgroundColor: '#17BE4C',
                                                color: 'white',
                                            }}
                                            className="rounded-md m-3"
                                            disabled={status === 'denied'}
                                        />
                                        <Button.Basic
                                            loader={
                                                status === 'denied'
                                                    ? requestMutation?.isLoading
                                                    : false
                                            }
                                            size="large"
                                            text="Deny"
                                            onClick={() =>
                                                requestHandler('denied')
                                            }
                                            buttonStyle={{
                                                backgroundColor: '#E71D36',
                                                color: 'white',
                                            }}
                                            className="rounded-md m-3"
                                            disabled={status === 'approved'}
                                        />
                                    </div>
                                </div>
                            )}
                        </Row>
                        {dropOrSwapDetailData?.status === 'pending' && (
                            <Row
                                style={{ background: 'white' }}
                                className="rounded-lg py-3 px-2"
                            >
                                {/* Header */}
                                <div className="w-full px-3">
                                    <h3 className="text-lg font-semibold">
                                        Potential Takers
                                    </h3>
                                </div>

                                {/* Check and Map Potential Takers */}
                                {dropOrSwapDetailData?.potentialTakers?.length >
                                0 ? (
                                    dropOrSwapDetailData.potentialTakers.map(
                                        (taker, index) => (
                                            <div
                                                key={taker.id || index}
                                                className="w-full flex items-center justify-between p-3 m-2 flex-wrap"
                                                style={{
                                                    border: '1px solid #F9F9FA',
                                                }}
                                            >
                                                {/* Avatar or Placeholder */}
                                                <div className="flex items-center gap-4">
                                                    {taker.profileImg ? (
                                                        <img
                                                            src={
                                                                taker?.user
                                                                    ?.profileImg
                                                            }
                                                            alt={
                                                                taker?.user
                                                                    ?.firstName ||
                                                                'Taker'
                                                            }
                                                            className="w-10 h-10 rounded-full"
                                                        />
                                                    ) : (
                                                        <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center">
                                                            <span className="text-white">
                                                                N/A
                                                            </span>
                                                        </div>
                                                    )}
                                                    {/* Name and Details */}
                                                    <div>
                                                        <p className="font-semibold">
                                                            {
                                                                taker?.user
                                                                    ?.firstName
                                                            }{' '}
                                                            {taker?.user
                                                                ?.lastName ||
                                                                ''}
                                                        </p>
                                                        <p className="text-sm text-gray-500">
                                                            {taker?.user
                                                                ?.email ||
                                                                'No email provided'}
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* Optional Additional Content */}
                                                <Text.Basic
                                                    text={'Personal'}
                                                    fontSize="14"
                                                    font-weight="500"
                                                    textAlign="start"
                                                />
                                            </div>
                                        ),
                                    )
                                ) : (
                                    <div className="w-full p-3">
                                        <p className="text-gray-500">
                                            No potential takers available.
                                        </p>
                                    </div>
                                )}
                            </Row>
                        )}
                    </Col>

                    {dropOrSwapDetailData?.status == 'approved' ||
                    (dropOrSwapDetailData?.status === 'accepted' &&
                        isRole !== 'supervisor') ? (
                        <Col
                            xl={8}
                            lg={8}
                            md={10}
                            sm={24}
                            xs={24}
                            style={{ background: 'white' }}
                            className="rounded-lg py-3 px-2 mb-6"
                        >
                            <Row
                                className="px-3 mb-4 w-full h-5/6 flex flex-col justify-start py-2 flex-nowrap"
                                style={{
                                    border: '1px solid #F9F9FA',
                                    height: '430px',
                                    overflowY: 'auto',
                                }}
                            >
                                <Row className="mb-4">
                                    <h3 className="text-lg font-semibold">
                                        Conversation / Activity
                                    </h3>
                                </Row>

                                <Row
                                    className="w-full mb-4"
                                    justify={'start'}
                                    align={'start'}
                                >
                                    <div
                                        style={{ border: '1px solid #F9F9FA' }}
                                        className="p-2 w-full"
                                    >
                                        <Text.Basic
                                            text={'Request Created'}
                                            fontSize="14"
                                            font-weight="600"
                                            textAlign="start"
                                        />
                                        <Text.Label
                                            text={`By ${dropOrSwapDetailData?.chatChannel?.initiatorUser?.first_name + ' ' + dropOrSwapDetailData?.chatChannel?.initiatorUser?.last_name} on ${DateTimeComponent(dropOrSwapDetailData?.createdAt, 'date')}  -  ${DateTimeComponent(dropOrSwapDetailData?.createdAt, 'time')}`}
                                            className="break-all text-start"
                                            style={{ fontSize: '12px' }}
                                        />
                                    </div>
                                </Row>
                                {messages?.length > 0 &&
                                    messages?.map((msg) => {
                                        return (
                                            <Row
                                                className="flex gap-2 w-full break-all mb-3 flex-nowrap items-center justify-center"
                                                justify={'start'}
                                                align={'start'}
                                                key={msg.messageId}
                                            >
                                                <div
                                                    className={`flex ${msg.messageSenderId == currentUserId ? 'items-end order-1' : ''}`}
                                                >
                                                    {msg.messageSenderImg ? (
                                                        <Avatar
                                                            src={
                                                                msg.messageSenderImg
                                                            }
                                                        />
                                                    ) : (
                                                        <Avatar
                                                            icon={
                                                                <UserOutlined />
                                                            }
                                                        />
                                                    )}
                                                </div>
                                                <div
                                                    className={`flex flex-col justify-center ${msg.messageSenderId == currentUserId ? 'items-end' : 'items-start'} w-10/12`}
                                                >
                                                    <Text.Basic
                                                        text={msg.message}
                                                        fontSize="12"
                                                        font-weight="400"
                                                        color="white"
                                                        textAlign="start"
                                                        className="py-1 px-2 rounded-md tracking-wide"
                                                        style={{
                                                            background:
                                                                msg.messageSenderId ==
                                                                currentUserId
                                                                    ? '#D3D3D3'
                                                                    : colorPrimary,
                                                        }}
                                                    />
                                                    <span
                                                        style={{
                                                            fontSize: '11px',
                                                            color: '#4E5D78',
                                                        }}
                                                    >
                                                        {dayjs(
                                                            msg.messageDateTime,
                                                        ).format(
                                                            'YYYY-MM-DD - HH:mm',
                                                        )}
                                                    </span>
                                                </div>
                                            </Row>
                                        );
                                    })}
                                <div ref={lastMessageRef} />
                            </Row>

                            <Row className="mt-3 py-2 flex items-center w-full mx-auto flex-nowrap">
                                <input
                                    placeholder="Enter Message here.."
                                    value={message}
                                    onChange={handleMessageChange}
                                    type="text"
                                    style={{
                                        background: '#F9F9FA',
                                        padding: '10px',
                                    }}
                                    className="w-4/5 outline-none"
                                />
                                <button
                                    style={{
                                        color: 'white',
                                        background: colorPrimary,
                                        padding: '10px',
                                    }}
                                    onClick={btnHandler}
                                    className="rounded-e w-5/12 sm:w-1/5 md:w-fit xl:w-1/5 px-3"
                                >
                                    Submit
                                </button>
                            </Row>
                        </Col>
                    ) : (
                        ''
                    )}
                </Row>
            )}
        </>
    );
};

export default DropSwapRequestDetail;
